export const ADD_ALERT = 'alert/ADD_ALERT';
export const DISMISS_ALERT = 'alert/DISMISS_ALERT';
export const DISMISS_ALERT_GROUP = 'alert/DISMISS_ALERT_GROUP';
